import * as React from 'react';

import { useLockFn, useRequest } from 'ahooks';
import { Button, Col, Flex, Form, notification, Row } from 'antd';

import {
  CheckOutlinedIcon,
  PrimitiveForm,
  PrimitiveSortableTreeSelect,
} from 'components';
import { getCategories, updateFooterInfo } from 'services';
import type { PageBuilderCategory, TreeSelectSource } from 'types';
import { generateTreeSelectData, normalizeToString } from 'utils';

type FieldType = {
  bestSellerCategoriesIds: TreeSelectSource[];
};

type PageBuilderFooterInfoProps = {
  bestSellerCategories: PageBuilderCategory[];
};

const PageBuilderFooterInfo = ({
  bestSellerCategories,
}: PageBuilderFooterInfoProps) => {
  const [form] = Form.useForm<FieldType>();
  const { data: categoriesData, loading: categoriesLoading } = useRequest(
    getCategories,
    {
      cacheKey: 'categories',
    },
  );

  const { categories = [] } = categoriesData ?? {};
  const categoriesTreeData = generateTreeSelectData(
    categories,
    'id',
    'title',
    'id',
  );
  const defaultCategories = bestSellerCategories.map(({ id, title }) => ({
    label: title,
    value: id,
  }));

  const onFinish = useLockFn(
    async ({ bestSellerCategoriesIds = [] }: FieldType) => {
      const ids = bestSellerCategoriesIds.map(({ value }) =>
        normalizeToString(value),
      );

      return updateFooterInfo({ bestSellerCategoriesIds: ids })
        .then(() => {
          notification.success({
            message: 'اطلاعات فوتر با موفقیت ذخیره شد.',
          });
        })
        .catch(message => {
          notification.error({ message });
        });
    },
  );

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Row className='px-6 pt-2'>
        <Col span={24}>
          <Form.Item<FieldType>
            label='دسته‌بندی‌های پرفروش'
            name='bestSellerCategoriesIds'
            extra='دسته‌بندی‌های پرفروش فوتر را انتخاب کنید و با کشیدن، ترتیب نمایش آن‌ها را تغییر دهید.'
            initialValue={defaultCategories}
          >
            <PrimitiveSortableTreeSelect
              placeholder='دسته‌بندی‌های پرفروش را انتخاب کنید'
              loading={categoriesLoading}
              treeData={categoriesTreeData}
            />
          </Form.Item>
        </Col>
      </Row>
      <Flex justify='end' className='px-6 pb-6'>
        <Form.Item className='mb-0'>
          <Button type='primary' htmlType='submit' icon={<CheckOutlinedIcon />}>
            ذخیره تغییرات
          </Button>
        </Form.Item>
      </Flex>
    </PrimitiveForm>
  );
};

export { PageBuilderFooterInfo };
